import { socket } from '../Containers/MainContainer'
import React from 'react'
import PaginationPluto from './Pagination'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { canUsePagination, numberWithCommas } from '../utils'
import { useState } from 'react'
import { useEffect } from 'react'
import PlutoMenu from './PlutoMenu'
import VerifyAdmin from './PlutoVerify'

function PlutoOfferWalls() {
    const [userProfile, setUserProfile] = useState({})
    const [earnings, setEarnings] = useState([0, 0, 0, 0, 0]);
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [rank, setRank] = useState(0)

    useEffect(() => {
        socket.on('response_get_admin_offerwalls', (data) => {

            setEarnings(data.withdrawals)
            setPageNumber(Math.ceil(data.withdrawalsLength / 5))
            setUserProfile(data)
            canUsePagination(true)
            setRank(data.rank)

        })
        socket.emit('getOfferWallsAdmin', {
            page,
        })
    }, [])
    return (
        <SkeletonTheme baseColor="#161b22" highlightColor="#21262d">

            <div className="modal-body" style={{ color: '#e6edf3', background: '#0d1117', minHeight: '100vh', padding: '24px' }}>

                {/* Stats Card */}
                <div style={{ marginBottom: '24px' }}>
                    {userProfile.withdrawalsLength != undefined ?
                        <div style={{
                            background: '#161b22',
                            border: '1px solid #21262d',
                            borderLeft: '3px solid #a855f7',
                            borderRadius: '12px',
                            padding: '16px 20px',
                            display: 'inline-block',
                        }}>
                            <p style={{ fontSize: '24px', fontWeight: 700, color: '#e6edf3', margin: 0 }}>
                                {numberWithCommas(userProfile.withdrawalsLength)}
                            </p>
                            <p style={{ fontSize: '12px', color: '#8b949e', margin: '4px 0 0 0', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Count OfferWalls</p>
                        </div>
                        : <Skeleton style={{ width: '136px', height: '50px' }} />}
                </div>

                {/* Data Table */}
                <div style={{
                    overflow: 'auto',
                    margin: '0 auto',
                    padding: '20px',
                    marginBottom: '20px',
                    background: '#161b22',
                    border: '1px solid #21262d',
                    borderRadius: '12px',
                }}>
                    <p style={{ color: '#e6edf3', fontWeight: 600, fontSize: '16px', marginBottom: '16px' }}>Offer Walls</p>

                    {/* Table Header */}
                    <div style={{ fontWeight: 500 }}>
                        <div className="user-details-table-elements" style={{ borderBottom: '1px solid #21262d', paddingBottom: '10px' }}>
                            <div style={{ minWidth: '250px', textAlign: 'left', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Name</div>
                            <div style={{ minWidth: '200px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Increase</div>
                            <div style={{ minWidth: '90px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Level Req</div>
                            <div style={{ minWidth: '50px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Has API</div>
                            <div style={{ minWidth: '100px', maxWidth: '100px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Edit</div>
                        </div>
                    </div>

                    {/* Table Rows */}
                    {earnings.map((earning, i) => {
                        return (
                            <div key={earning.id} className="user-details-table-elements admin-a" style={{ color: '#e6edf3', borderBottom: '1px solid #21262d' }}>
                                <div style={{ minWidth: '250px', textAlign: 'left', color: '#e6edf3' }} >{earning.name || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '200px', color: '#c9d1d9' }} >{earning.increase || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '90px', color: '#c9d1d9' }} >{earning.level_req || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '50px', color: '#c9d1d9' }} >{earning.has_api || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{
                                    minWidth: '100px',
                                    maxWidth: '100px',
                                    height: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: '#21262d',
                                    border: '1px solid #30363d',
                                    borderRadius: '8px',
                                    color: '#c9d1d9',
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                }} >{earning.id == undefined ? <Skeleton style={{ width: '30px' }} /> : 'Edit'}</div>
                            </div>
                        )
                    })}
                </div>

                {pageNumber == -1 ? <Skeleton style={{ width: '100%' }} /> : <PaginationPluto pageNumber={pageNumber} requestNewList={(page) => {
                    canUsePagination(false)
                    setEarnings([0, 0, 0, 0, 0])
                    socket.emit('getOfferWallsAdmin', {
                        username_like: username,
                        page,
                    })
                }} />}

            </div>

        </SkeletonTheme>
    )
}

export default PlutoOfferWalls
